export default __webpack_public_path__ + "static/media/image-5.60e7e928.webp";